import type { JSX } from "react";
import { useRef } from "react";

import { AlertDialog as BaseAlertDialog } from "@base-ui/react/alert-dialog";

import { AlertDialogAnimationContext } from "./AlertDialog.context";
import type { AlertDialogProps } from "./AlertDialog.types";

export function AlertDialog({
  originRef: originRefProp,
  ...props
}: AlertDialogProps): JSX.Element {
  const internalOriginRef = useRef<DOMRect | null>(null);
  const originRef = originRefProp ?? internalOriginRef;

  return (
    <AlertDialogAnimationContext.Provider value={originRef}>
      <BaseAlertDialog.Root data-slot="alert-dialog" {...props} />
    </AlertDialogAnimationContext.Provider>
  );
}
